import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agreementStatusColor',
})
export class AgreementStatusColorPipe implements PipeTransform {
  transform(agreementStatus: string): unknown {
    let chipColor = 'blue-50';

    switch (agreementStatus) {
      case 'urgent':
        chipColor = 'orange-25';
        break;
      case 'offer_decline':
      case 'red-500':
      case 'terminated':
        chipColor = 'red-50';
        break;

      case 'accepted':
      case 'amendments_accepted':
      case 'amendments_declined':
        chipColor = 'green-50';
        break;

      default:
    }
    return chipColor;
  }
}
